import BaseService from '@/services/BaseService'

class TrocaVendaService extends BaseService {
    constructor(){
        super('/v1/troca-venda')
    }
}

export default new TrocaVendaService